import type { ReactElement } from 'react';
import { Card, Skeleton, cn } from '@xdocs/ui';
import styles from './KpiTile.module.css';

export interface KpiTileProps {
  label: string;
  value: string;
  /** Already-localized secondary line (e.g. "+12% MoM") — omitted when there's nothing to show. */
  delta?: string;
  loading?: boolean;
  className?: string | undefined;
}

/** KPI stat tile (design/app/38-admin-overview.html / 43-admin-analytics.html
 * `metrics`/tile grid): mono-caps label, large display-font value, optional
 * mono delta line. Ships its own loading skeleton (E19) — callers render it
 * with `loading` while the analytics op is in flight instead of a bare
 * spinner over the whole KPI row. */
export function KpiTile({ label, value, delta, loading = false, className }: KpiTileProps): ReactElement {
  return (
    <Card className={cn(styles['tile'], className)}>
      <div className={cn(styles['label'])}>{label}</div>
      {loading ? (
        <Skeleton shape="text-line" width="70%" height="26px" />
      ) : (
        <div className={cn(styles['value'])}>{value}</div>
      )}
      {!loading && delta && <div className={cn(styles['delta'])}>{delta}</div>}
    </Card>
  );
}
